import React, { useRef } from "react";
import "../styles/HeroSection.css";
import { useNavigate } from "react-router-dom";

import Lottie from "lottie-react";
import leavesAnimation from "../leaves.json";

const HeroSection = () => {
  const navigate = useNavigate();
  const lottieRef = useRef();

  const downloadCV = () => {
    const link = document.createElement("a");
    link.href = "CV.pdf";
    link.download = "Frank_Fundel_CV.pdf";
    link.click();
  };

  return (
    <div className="hero-section">
      <div className="hero-text">
        <h1
          style={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          Frank Fundel{" "}
          <Lottie
            lottieRef={lottieRef}
            animationData={leavesAnimation}
            loop={false}
            autoplay={true}
            style={{
              width: 40,
              marginLeft: 4,
              marginTop: 16,
            }}
            initialSegment={[0, 20]}
            onDOMLoaded={() => {
              lottieRef.current.setSpeed(2);
            }}
          />
        </h1>
        <p>
          I am currently working as a PhD student in the{" "}
          <b>Computer Vision & Learning group</b> at LMU Munich (
          <a href="https://ommer-lab.com/" target="_blank" rel="noreferrer">
            Ommer-Lab
          </a>
          ). I have a minor in biology and master in computer science and
          specifically focused on <b>bats and bioacoustics</b>, working with
          Prof. Tschapka. I voluntarly work in <b>bat rehabilitation</b>{" "}
          organziations for over four years now, mainly conducting educational
          lectures and emergency care. I enjoy being outdoors, running, hiking,
          and scuba diving.
        </p>
        <ul className="social-links">
          <li>
            <a
              href="https://github.com/FrankFundel"
              target="_blank"
              rel="noreferrer"
            >
              GitHub
            </a>
          </li>
          <li>/</li>
          <li>
            <a
              href="https://www.linkedin.com/in/frank-fundel-804ba61b3/"
              target="_blank"
              rel="noreferrer"
            >
              LinkedIn
            </a>
          </li>
          <li>/</li>
          <li>
            <a href="https://x.com/frnkfndl" target="_blank" rel="noreferrer">
              Twitter
            </a>
          </li>
          <li>/</li>
          <li>
            <a
              href="https://scholar.google.de/citations?user=1_049o0AAAAJ&hl=de"
              target="_blank"
              rel="noreferrer"
            >
              Google Scholar
            </a>
          </li>
        </ul>
      </div>
      <div className="hero-profile">
        <img src="profile.webp" alt="Frank Fundel" className="profile-image" />
        <button className="download-cv" onClick={downloadCV}>
          Download CV
        </button>
        <div className="bio-counters">
          <div className="bat-guidings">
            <p className="counter-number">16</p>
            <p style={{ margin: 0 }}>Bat Guidings</p>
          </div>
          <div className="bat-guidings">
            <p className="counter-number">3</p>
            <p style={{ margin: 0 }}>Ghost Net Divings</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
